var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: _vm.getWidth(), height: _vm.getHeight() }),attrs:{"id":"art"}},_vm._l((_vm.getPixelCount()),function(p){return _c('Pixel',{key:p,attrs:{"background":_vm.getPixelBackground(p),"coloring":_vm.color,"id":p,"func":_vm.func,"pixelDimensions":_vm.getPixelDimensions()}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }